import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-content" }

import { computed } from 'vue';
import UserHeader from '../UserHeader';
import { useRouting } from '@/composables';


export default /*@__PURE__*/_defineComponent({
  __name: 'User',
  setup(__props) {

const $routing = useRouting();
const isFromAdminRoute = computed<boolean>(() => $routing.route.name === 'administrators.userProfile');

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isFromAdminRoute.value)
      ? (_openBlock(), _createBlock(_unref(UserHeader), { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterView)
    ])
  ], 64))
}
}

})